import { Box, CircularProgress, Typography } from '@mui/material'
import { SearchBar } from 'components/SearchBar/SearchBar'
import { useGetUserPlaces } from 'hooks/usePlaces'
import { useGetDeliveryAreaGroups } from 'hooks/useServiceAreas'
import { t } from 'i18next'
import { useAuth } from 'providers/AuthProvider'
import { Dispatch, Fragment, SetStateAction, useState } from 'react'
import { DeliveryAreaGroup } from 'types/model/common'
import { DeliveryAreaGroupBtn, SidebarBtn } from './ServiceArea.styled'

type Props = {
  selectedAreaGroup: DeliveryAreaGroup | null
  setSelectedAreaGroup: Dispatch<SetStateAction<DeliveryAreaGroup | null>>
  setSelectedPlaceId: Dispatch<SetStateAction<string>>
}

export const SearchDeliveryGroups = ({
  setSelectedAreaGroup,
  selectedAreaGroup,
  setSelectedPlaceId,
}: Props) => {
  const [input, setInput] = useState<string>('')
  const [query, setQuery] = useState<string>()
  const [enabled, setEnabled] = useState('false')
  const [placeId, setPlaceId] = useState('')
  const { userStores } = useAuth()
  const { isLoading, places, error } = useGetUserPlaces(
    userStores,
    query,
    enabled
  )
  const {
    isLoading: isLoadingGroups,
    isFetching,
    allDeliveryAreas,
  } = useGetDeliveryAreaGroups(placeId as string)

  const handleSearch = () => {
    setQuery(input)
    setEnabled('true')
  }

  const handleSelectGroup = (group: DeliveryAreaGroup) => {
    setSelectedAreaGroup(group)
    setSelectedPlaceId(placeId)
  }

  return (
    <Box mt={2}>
      <SearchBar
        width='100%'
        input={input}
        setInput={setInput}
        placeholderText={t('searchPlacesPlaceholder')}
        handleClick={handleSearch}
        ariaLabel={t('searchPlaces')}
      />
      {query && (error || !places) && (
        <Typography>{t('noSearchResultWithQuery')}</Typography>
      )}
      {isLoading && (
        <Box display='flex' justifyContent='center' width='100%'>
          <CircularProgress />
        </Box>
      )}
      <Box display='flex' flexDirection='column' alignItems='flex-start'>
        {places &&
          places.map((place) => (
            <Fragment key={place.value}>
              <SidebarBtn
                selected={false}
                onClick={() => setPlaceId(place.value)}>
                <Typography variant='body2'>{place.label}</Typography>
              </SidebarBtn>
              {placeId === place.value && (isLoadingGroups || isFetching) && (
                <Box display='flex' justifyContent='center' width='100%'>
                  <CircularProgress />
                </Box>
              )}
              {!isLoadingGroups &&
                !isFetching &&
                placeId === place.value &&
                allDeliveryAreas?.length > 0 &&
                allDeliveryAreas.map((group: DeliveryAreaGroup) => {
                  return (
                    <DeliveryAreaGroupBtn
                      key={group.id}
                      onClick={async () => handleSelectGroup(group)}
                      selected={group.id === selectedAreaGroup?.id}>
                      {group.name}
                    </DeliveryAreaGroupBtn>
                  )
                })}
            </Fragment>
          ))}
      </Box>
    </Box>
  )
}
